import { render, staticRenderFns } from "./LeftLowerBarPerspective.vue?vue&type=template&id=70124002&scoped=true&"
import script from "./LeftLowerBarPerspective.vue?vue&type=script&lang=js&"
export * from "./LeftLowerBarPerspective.vue?vue&type=script&lang=js&"
import style0 from "./LeftLowerBarPerspective.vue?vue&type=style&index=0&id=70124002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70124002",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70124002')) {
      api.createRecord('70124002', component.options)
    } else {
      api.reload('70124002', component.options)
    }
    module.hot.accept("./LeftLowerBarPerspective.vue?vue&type=template&id=70124002&scoped=true&", function () {
      api.rerender('70124002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/LowerBar/LowerBarLeftSide/LeftLowerBarPerspective.vue"
export default component.exports